import { useState } from "react";
import { rich } from "./RichText";

export type FaqEntry = { q: string; a: string };

export function Faq({ items }: { items: FaqEntry[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="kk-faq">
      {items.map((item, i) => {
        const isOpen = openIndex === i;
        return (
          <div key={item.q} className={`kk-faq__item${isOpen ? " is-open" : ""}`}>
            <button
              type="button"
              className="kk-faq__summary"
              aria-expanded={isOpen}
              onClick={() => setOpenIndex(isOpen ? null : i)}
            >
              <span>{item.q}</span>
              <span className="kk-faq__icon" aria-hidden="true">
                +
              </span>
            </button>
            <div className="kk-faq__content" role="region">
              <p>{rich(item.a)}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
